module.exports = __webpack_public_path__ + "static/media/delivery-bike.881c1ca8.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/delivery-bike.png
// module id = 265
// module chunks = 0